<script setup lang="ts">
interface Props {
    strokeWidth?: string | number
    primary?: boolean
    electric?: boolean
    gas?: boolean
    white?: boolean
    font?: boolean
    secondary?: boolean
}

withDefaults(defineProps<Props>(), {
    strokeWidth: 2,
    primary: false,
    white: false,
    font: false,
    electric: false,
    gas: false,
    secondary: false,
})
</script>

<template>
    <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="[
            'meter-icon',
            {
                'meter-icon--primary': primary,
                'meter-icon--white': white,
                'meter-icon--font': font,
                'meter-icon--electric': electric,
                'meter-icon--gas': gas,
                'meter-icon--secondary': secondary,
            },
        ]"
    >
        <path
            d="M10.3405 1.25H2.38631C1.75874 1.25 1.25 1.75874 1.25 2.38631V10.3405C1.25 10.9681 1.75874 11.4768 2.38631 11.4768H10.3405C10.9681 11.4768 11.4768 10.9681 11.4768 10.3405V2.38631C11.4768 1.75874 10.9681 1.25 10.3405 1.25Z"
            stroke="#3b64b1"
            :stroke-width="strokeWidth / 2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M1.25 4.65894H11.4768"
            stroke="#3b64b1"
            :stroke-width="strokeWidth / 2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.65918 11.4768V4.65894"
            stroke="#3b64b1"
            :stroke-width="strokeWidth / 2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
